import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { encodeUrl } from "../../utils/urlHelper";
import settings from "../../settings";

const SEARCH_PREFIX = "/search";

class ClassicMenu extends Component {
  constructor(props) {
    super(props);
    this.loadMenu(props);
  }

  loadMenu = (props) => {
    const { uiData, history } = this.props;
    const topMenus = [];
    const pathName =
      history &&
      (history.location.pathname.indexOf(SEARCH_PREFIX) !== -1
        ? history.location.pathname.substring(SEARCH_PREFIX.length)
        : history.location.pathname);
    const pathTokens = pathName && pathName.split("/");
    const subMenus = [];
    subMenus.push(
      <ul
        id={`sub_menu_${0}`}
        key={`sub_menu_${0}`}
        className="sub-menu-list no-bullet no-padding-left"
        style={{ display: "none" }}
      >
        <li className="padding-left-20">
          Your subscription includes the following searches
        </li>
      </ul>
    );
    let menuLength = 0;
    let currentSelectedMenuIndex = 0;
    if (
      uiData !== null &&
      uiData !== undefined &&
      uiData.Menus !== null &&
      uiData.Menus !== undefined
    ) {
      menuLength = uiData.Menus.TopMenuVsSubMenuItems.length;
      _.map(uiData.Menus.TopMenuItems, (tm, index) => {
        const item = uiData.Menus.TopMenuVsSubMenuItems[tm];
        const subMenuItems = [];
        const mainMenu = _.find(
          uiData.Menus.MenuItems,
          (a) => a.MenuId === parseInt(tm, 10)
        );
        let firstSubMenuUri = "";
        _.map(item, (val) => {
          const subMenu = _.find(
            uiData.Menus.MenuItems,
            (a) => a.MenuId === val
          );
          const leftMenus =
            uiData.Menus.SubMenuVsLeftMenuItems[`${subMenu.MenuId}`];
          let firstLeftMenu;
          if (leftMenus !== undefined) {
            firstLeftMenu = _.find(
              uiData.Menus.MenuItems,
              (a) => a.MenuId === parseInt(leftMenus[0], 10)
            );
            _.forEach(leftMenus, (lmId) => {
              const lm = _.find(
                uiData.Menus.MenuItems,
                (a) => a.MenuId === lmId
              );
              const report = _.find(
                uiData.Reports,
                (a) => a.ReportID === lm.ReportId
              );
              if (report && report.DefaultForMenu) {
                firstLeftMenu = lm;
              }
            });
          }
          if (firstSubMenuUri === "")
            firstSubMenuUri = `/search/${encodeUrl(
              mainMenu.MenuTitle
            )}/${encodeUrl(subMenu.MenuTitle)}${
              firstLeftMenu !== undefined
                ? `/${encodeUrl(firstLeftMenu.MenuTitle)}/${
                    firstLeftMenu.MenuId
                  }`
                : ""
            }`;
          subMenuItems.push(
            <li
              key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
              className="maintabsul sub-menu-list-item"
            >
              <a
                className={
                  pathTokens &&
                  pathTokens.length > 2 &&
                  decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
                    ? "top_menu_sublink_selected"
                    : "top_menu_sublink_unselected"
                }
                href={`/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
                  subMenu.MenuTitle
                )}${
                  firstLeftMenu !== undefined
                    ? `/${encodeUrl(firstLeftMenu.MenuTitle)}/${
                        firstLeftMenu.MenuId
                      }`
                    : ""
                }`}
              >
                {subMenu.MenuTitle}
              </a>
            </li>
          );
        });

        if (
          pathTokens &&
          pathTokens.length > 0 &&
          decodeURIComponent(pathTokens[1]) === mainMenu.MenuTitle
        ) {
          currentSelectedMenuIndex = tm;
          subMenus.push(
            <ul
              id={`sub_menu_${tm}`}
              key={`sub_menu_${tm}`}
              className="sub-menu-list no-bullet no-padding-left"
            >
              {subMenuItems}
            </ul>
          );
        } else {
          subMenus.push(
            <ul
              id={`sub_menu_${tm}`}
              key={`sub_menu_${tm}`}
              className="sub-menu-list no-bullet no-padding-left"
              style={{ display: "none" }}
            >
              {subMenuItems}
            </ul>
          );
        }
        const isNewMenu = settings.highlightAddNewBadgeMenus.includes(tm);
        const menuBorderClass = isNewMenu ? "mew-menu-border" : "";
        topMenus.push(
          <li
            className="maintabsul"
            key={`top_menu_${index}`}
            onMouseOver={this.handleMouseOver}
            id={`menu_${mainMenu.MenuId}`}
          >
            <a
              role={"button"}
              tabIndex={index}
              className={
                pathTokens &&
                pathTokens.length > 0 &&
                decodeURIComponent(pathTokens[1]) === mainMenu.MenuTitle
                  ? `top_menu_tab_selected ${menuBorderClass}`
                  : `top_menu_tab_unselected ${menuBorderClass}`
              }
              href={firstSubMenuUri}
            >
              {mainMenu.MenuTitle} 
              {isNewMenu && <span className="new-menu-label" htmlFor="newMenu">New!</span>}
            </a>
          </li>
        );
      });
    }
    const mySearchSubmenu = [];
    const mainMenu = settings.myAccountMenuItem;
    let firstAccountMenuUri = "";
    _.forEach(settings.myAccountMenuItem.subMenuItems, (subMenu) => {
      if (firstAccountMenuUri === "") {
        firstAccountMenuUri = `/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
          subMenu.MenuTitle
        )}`;
      }
      mySearchSubmenu.push(
        <li
          key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
          className="maintabsul sub-menu-list-item"
        >
          <a
            className={
              pathTokens &&
              pathTokens.length > 2 &&
              decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
                ? "top_menu_sublink_selected"
                : "top_menu_sublink_unselected"
            }
            href={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
              subMenu.MenuTitle
            )}`}
          >
            {subMenu.MenuTitle}
          </a>
        </li>
      );
    });

    if (props.userAccount.acctMasterUser === "1") {
      const myCharges = "My Charges";
      mySearchSubmenu.push(
        <li
          key={`menu_${mainMenu.MenuTitle}_${myCharges}`}
          className="maintabsul sub-menu-list-item"
        >
          <a
            className={
              pathTokens &&
              pathTokens.length > 2 &&
              decodeURIComponent(pathTokens[2]) === myCharges
                ? "top_menu_sublink_selected"
                : "top_menu_sublink_unselected"
            }
            href={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(myCharges)}`}
          >
            {myCharges}
          </a>
        </li>
      );
    }

    const myprofile = "My Profile";

    mySearchSubmenu.push(
      <li
        key={`menu_${mainMenu.MenuTitle}_${myprofile}`}
        className="maintabsul sub-menu-list-item"
      >
        <a
          className={
            pathTokens &&
            pathTokens.length > 2 &&
            decodeURIComponent(pathTokens[2]) === myprofile
              ? "top_menu_sublink_selected"
              : "top_menu_sublink_unselected"
          }
          href={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(myprofile)}`}
        >
          {myprofile}
        </a>
      </li>
    );

    topMenus.push(
      <li
        className="maintabsul last-menu-item"
        key={`top_menu_${menuLength}`}
        onMouseOver={this.handleMouseOver}
        id={"menu_100"}
      >
        <a
          role={"button"}
          tabIndex={menuLength}
          className={
            pathTokens &&
            pathTokens.length > 0 &&
            decodeURIComponent(pathTokens[1]) ===
              settings.myAccountMenuItem.MenuTitle
              ? "top_menu_tab_selected last-menu-item"
              : "top_menu_tab_unselected last-menu-item"
          }
          href={firstAccountMenuUri}
        >
          {settings.myAccountMenuItem.MenuTitle}
        </a>
      </li>
    );

    if (
      pathTokens &&
      pathTokens.length > 0 &&
      decodeURIComponent(pathTokens[1]) === settings.myAccountMenuItem.MenuTitle
    ) {
      currentSelectedMenuIndex = 100;
      subMenus.push(
        <ul
          id={`sub_menu_${100}`}
          key={`sub_menu_${100}`}
          className="sub-menu-list no-bullet no-padding-left"
        >
          {mySearchSubmenu}
        </ul>
      );
    } else {
      subMenus.push(
        <ul
          id={`sub_menu_${100}`}
          key={`sub_menu_${100}`}
          className="sub-menu-list no-bullet no-padding-left"
          style={{ display: "none" }}
        >
          {mySearchSubmenu}
        </ul>
      );
    }

    this.state = {
      currentSelectedMenuIndex,
      topMenus,
      subMenus,
      mouseOverMenuIndex: -1,
    };
  };

  handleMouseOver = (e) => {
    const {
      currentSelectedMenuIndex,
      mouseOverMenuIndex
    } = this.state;

    const currentSubMenu = document.getElementById(
      `sub_menu_${currentSelectedMenuIndex}`
    );

    if (currentSubMenu) {
      currentSubMenu.style.display = "none";
    }

    if (mouseOverMenuIndex > -1) {
      const previousSubMenu = document.getElementById(
        `sub_menu_${mouseOverMenuIndex}`
      );

      if (previousSubMenu) {
        previousSubMenu.style.display = "none";
      }
    }

    const menuId = e.currentTarget.id;

    if (!menuId) {
      return;
    }

    const newMouseOverMenuIndex = menuId.replace("menu_", "");

    const newSubMenu = document.getElementById(
      `sub_menu_${newMouseOverMenuIndex}`
    );

    if (newSubMenu) {
      newSubMenu.style.display = "block";
    }

    this.setState({
      mouseOverMenuIndex: newMouseOverMenuIndex
    });
  };

  handleMouseLeave = () => {
    const {
      currentSelectedMenuIndex,
      mouseOverMenuIndex
    } = this.state;

    if (mouseOverMenuIndex > -1) {
      const mouseOverSubMenu = document.getElementById(
        `sub_menu_${mouseOverMenuIndex}`
      );

      if (mouseOverSubMenu) {
        mouseOverSubMenu.style.display = "none";
      }
    }

    const selectedSubMenu = document.getElementById(
      `sub_menu_${currentSelectedMenuIndex}`
    );

    if (selectedSubMenu) {
      selectedSubMenu.style.display = "block";
    }
  };

  render() {
    return (
      <div className={`no-print`}>
        <Table
          className="table-no-border background-color-transparent"
          onMouseLeave={this.handleMouseLeave}
        >
          <Table.Body>
            <Table.Row>
              <Table.Cell className="no-padding">
                <div id="navigation" className="maintabs">
                  <ul className="maintabsul no-padding-left" id="mymenu">
                    {this.state != null && this.state.topMenus}
                  </ul>
                </div>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell className="no-padding">
                <div
                  id="sublinks"
                  name="sublinks"
                  className="submenu_background sublink_boxShadow grey_border"
                >
                  {this.state != null && this.state.subMenus}
                </div>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default ClassicMenu;



// WEBPACK FOOTER //
// ./src/components/pages/ClassicMenu.js